package com.rainbowclubs.rainbow

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.tooling.preview.Preview
import com.rainbowclubs.rainbow.navigation.RainbowNavigation
import com.rainbowclubs.rainbow.presentation.theme.RainbowClubTheme

@Composable
@Preview
fun App() {
    RainbowClubTheme {
        Column(
            modifier = Modifier
                .background(
                    Brush.verticalGradient(
                        // TODO Move this to the theme
                        colors = listOf(
                            Color(0xFFFFD1D1).copy(alpha = 0.3f),
                            Color(0xFFD1E4FF).copy(alpha = 0.3f),
                            Color(0xFFFFFBF8)
                        )
                    )
                )
                .appContentPadding()
                .fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            RainbowNavigation()
        }
    }
}
